import { Image, NormalizedObjectsString } from '../shared/types';

export enum ViewType {
  Weekly = 0,
  Monthly = 1
}

export interface Section {
  id: number;
  order_nr: number;
  title: string;
  image?: Image;
  view?: ViewType;
}

export const enum SectionActionTypes {
  FETCH_REQUEST = '[section]FETCH_REQUEST',
  FETCH_SUCCESS = '[section]FETCH_SUCCESS',
  FETCH_ERROR = '[section]FETCH_ERROR',
  SELECT_SECTION = '[section]SELECT_SECTION',
  SELECTED = '[section]SELECTED',
  CREATE_SECTION = '[section]CREATE_SECTION',
  REMOVE_SECTION = '[section]DELETE',
  UPDATE_SECTION = '[section]UPDATE_SECTION'
}

export type ISectionData = NormalizedObjectsString<Section>;

export interface SectionState {
  readonly loading: boolean;
  readonly data: ISectionData;
  readonly errors?: Error;
}



// WEBPACK FOOTER //
// ./src/store/sections/types.ts